var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"LKIconToggle",class:{ 'is-active': _vm.active }},[(_vm.loading)?[_vm._v(" mdi-spin mdi-sync ")]:[_vm._v(" mdi-chevron-down ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }